var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError } from '@wix/metro-runtime/velo';
import * as ambassadorWixMembersV1CustomField from '@wix/ambassador-members-v1-custom-field/http';
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
export var Privacy;
(function (Privacy) {
    Privacy["UNKNOWN"] = "UNKNOWN";
    Privacy["PUBLIC"] = "PUBLIC";
    Privacy["PRIVATE"] = "PRIVATE";
})(Privacy || (Privacy = {}));
export var Type;
(function (Type) {
    Type["UNKNOWN"] = "UNKNOWN";
    Type["TEXT"] = "TEXT";
    Type["NUMBER"] = "NUMBER";
    Type["DATE"] = "DATE";
    Type["URL"] = "URL";
    Type["SOCIAL"] = "SOCIAL";
})(Type || (Type = {}));
export var SocialTypeType;
(function (SocialTypeType) {
    SocialTypeType["UNKNOWN"] = "UNKNOWN";
    SocialTypeType["FACEBOOK"] = "FACEBOOK";
    SocialTypeType["INSTAGRAM"] = "INSTAGRAM";
    SocialTypeType["LINKEDIN"] = "LINKEDIN";
    SocialTypeType["TWITTER"] = "TWITTER";
    SocialTypeType["YOUTUBE"] = "YOUTUBE";
    SocialTypeType["PINTEREST"] = "PINTEREST";
    SocialTypeType["TIKTOK"] = "TIKTOK";
    SocialTypeType["DEVIANTART"] = "DEVIANTART";
    SocialTypeType["SOUNDCLOUD"] = "SOUNDCLOUD";
    SocialTypeType["TUMBLR"] = "TUMBLR";
    SocialTypeType["VIMEO"] = "VIMEO";
    SocialTypeType["VKONTAKTE"] = "VKONTAKTE";
    SocialTypeType["ODNOKLASSNIKI"] = "ODNOKLASSNIKI";
    SocialTypeType["OTHER"] = "OTHER";
})(SocialTypeType || (SocialTypeType = {}));
export var Origin;
(function (Origin) {
    Origin["UNKNOWN"] = "UNKNOWN";
    Origin["CUSTOM"] = "CUSTOM";
    Origin["CONTACT"] = "CONTACT";
    Origin["SYSTEM"] = "SYSTEM";
})(Origin || (Origin = {}));
export var AppliesTo;
(function (AppliesTo) {
    AppliesTo["ALL_MEMBERS"] = "ALL_MEMBERS";
    AppliesTo["SELECTED_MEMBERS"] = "SELECTED_MEMBERS";
})(AppliesTo || (AppliesTo = {}));
export var Section;
(function (Section) {
    Section["GENERAL"] = "GENERAL";
    Section["SOCIAL"] = "SOCIAL";
    Section["DISPLAY_INFO"] = "DISPLAY_INFO";
    Section["ADDRESS"] = "ADDRESS";
})(Section || (Section = {}));
export var State;
(function (State) {
    State["UNKNOWN"] = "UNKNOWN";
    State["ENABLED"] = "ENABLED";
    State["DISABLED"] = "DISABLED";
    State["PENDING"] = "PENDING";
    State["DEMO"] = "DEMO";
})(State || (State = {}));
export var SiteCreatedContext;
(function (SiteCreatedContext) {
    /** A valid option, we don't expose all reasons why site might be created. */
    SiteCreatedContext["OTHER"] = "OTHER";
    /** A meta site was created from template. */
    SiteCreatedContext["FROM_TEMPLATE"] = "FROM_TEMPLATE";
    /** A meta site was created by copying of the transfferred meta site. */
    SiteCreatedContext["DUPLICATE_BY_SITE_TRANSFER"] = "DUPLICATE_BY_SITE_TRANSFER";
    /** A copy of existing meta site. */
    SiteCreatedContext["DUPLICATE"] = "DUPLICATE";
    /** A meta site was created as a transfferred site (copy of the original), old flow, should die soon. */
    SiteCreatedContext["OLD_SITE_TRANSFER"] = "OLD_SITE_TRANSFER";
    /** deprecated A meta site was created for Flash editor. */
    SiteCreatedContext["FLASH"] = "FLASH";
})(SiteCreatedContext || (SiteCreatedContext = {}));
export var Namespace;
(function (Namespace) {
    Namespace["UNKNOWN_NAMESPACE"] = "UNKNOWN_NAMESPACE";
    /** Default namespace for UGC sites. MetaSites with this namespace will be shown in a user's site list by default. */
    Namespace["WIX"] = "WIX";
    /** ShoutOut stand alone product. These are siteless (no actual Wix site, no HtmlWeb). MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["SHOUT_OUT"] = "SHOUT_OUT";
    /** MetaSites created by the Albums product, they appear as part of the Albums app. MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["ALBUMS"] = "ALBUMS";
    /** Part of the WixStores migration flow, a user tries to migrate and gets this site to view and if the user likes it then stores removes this namespace and deletes the old site with the old stores. MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["WIX_STORES_TEST_DRIVE"] = "WIX_STORES_TEST_DRIVE";
    /** Hotels standalone (siteless). MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["HOTELS"] = "HOTELS";
    /** Clubs siteless MetaSites, a club without a wix website. MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["CLUBS"] = "CLUBS";
    /** A partially created ADI website. MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["ONBOARDING_DRAFT"] = "ONBOARDING_DRAFT";
    /** AppBuilder for AppStudio / shmite (c). MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["DEV_SITE"] = "DEV_SITE";
    /** LogoMaker websites offered to the user after logo purchase. MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["LOGOS"] = "LOGOS";
    /** VideoMaker websites offered to the user after video purchase. MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["VIDEO_MAKER"] = "VIDEO_MAKER";
    /** MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["PARTNER_DASHBOARD"] = "PARTNER_DASHBOARD";
    /** MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["DEV_CENTER_COMPANY"] = "DEV_CENTER_COMPANY";
    /**
     * A draft created by HTML editor on open. Upon "first save" it will be moved to be of WIX domain.
     *
     * Meta site with this namespace will *not* be shown in a user's site list by default.
     */
    Namespace["HTML_DRAFT"] = "HTML_DRAFT";
    /**
     * the user-journey for Fitness users who want to start from managing their business instead of designing their website.
     * Will be accessible from Site List and will not have a website app.
     * Once the user attaches a site, the site will become a regular wixsite.
     */
    Namespace["SITELESS_BUSINESS"] = "SITELESS_BUSINESS";
    /** Belongs to "strategic products" company. Supports new product in the creator's economy space. */
    Namespace["CREATOR_ECONOMY"] = "CREATOR_ECONOMY";
    /** It is to be used in the Business First efforts. */
    Namespace["DASHBOARD_FIRST"] = "DASHBOARD_FIRST";
    /** Bookings business flow with no site. */
    Namespace["ANYWHERE"] = "ANYWHERE";
    /** Namespace for Headless Backoffice with no editor */
    Namespace["HEADLESS"] = "HEADLESS";
    /**
     * Namespace for master site that will exist in parent account that will be referenced by subaccounts
     * The site will be used for account level CSM feature for enterprise
     */
    Namespace["ACCOUNT_MASTER_CMS"] = "ACCOUNT_MASTER_CMS";
    /** Rise.ai Siteless account management for Gift Cards and Store Credit. */
    Namespace["RISE"] = "RISE";
    /**
     * As part of the branded app new funnel, users now can create a meta site that will be branded app first.
     * There's a blank site behind the scene but it's blank).
     * The Mobile company will be the owner of this namespace.
     */
    Namespace["BRANDED_FIRST"] = "BRANDED_FIRST";
})(Namespace || (Namespace = {}));
export var DeleteStatus;
(function (DeleteStatus) {
    DeleteStatus["UNKNOWN"] = "UNKNOWN";
    DeleteStatus["TRASH"] = "TRASH";
    DeleteStatus["DELETED"] = "DELETED";
    DeleteStatus["PENDING_PURGE"] = "PENDING_PURGE";
})(DeleteStatus || (DeleteStatus = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
const _createCustomFieldRequest = {};
const _createCustomFieldResponse = {};
const _deleteCustomFieldRequest = {};
const _deleteCustomFieldResponse = {};
const _getCustomFieldRequest = {};
const _getCustomFieldResponse = {};
const _hideCustomFieldRequest = {};
const _hideCustomFieldResponse = {};
const _listCustomFieldsRequest = {};
const _listCustomFieldsResponse = {};
const _updateCustomFieldRequest = {};
const _updateCustomFieldResponse = {};
const _updateCustomFieldsOrderRequest = {};
const _updateCustomFieldsOrderResponse = {};
/**
 * Creates a custom field.
 * @param field - Custom field to create.
 * @public
 * @documentationMaturity preview
 * @requiredField field
 * @requiredField field.name
 * @adminMethod
 * @returns Newly created custom field.
 */
export function createCustomField(field) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { field: '$[0]' };
        const responseTransformation = '$.field';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _createCustomFieldRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['field']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _createCustomFieldResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['field']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([field]);
        const reqOpts = ambassadorWixMembersV1CustomField.createCustomField(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'field',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves a custom field by id.
 * @param _id - Custom field ID.
 * @public
 * @documentationMaturity preview
 * @requiredField _id
 */
export function getCustomField(_id) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { id: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getCustomFieldRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getCustomFieldResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['field']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([_id]);
        const reqOpts = ambassadorWixMembersV1CustomField.getCustomField(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                '_id',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Returns ordered custom fields, given the provided paging.
 *
 * The fields are ordered by section in such sequence:
 * - `GENERAL`
 * - `DISPLAY_INFO`
 * - `SOCIAL`
 * The fields within same section are ordered with respect to the saved fields order.
 *
 * To modify the order of fields within sections, use [`Update Custom Fields Order`]().
 * @public
 * @documentationMaturity preview
 * @adminMethod
 */
export function listCustomFields(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { paging: '$[0].paging' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _listCustomFieldsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _listCustomFieldsResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#fields']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixMembersV1CustomField.listCustomFields(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Updates a custom field.
 *
 * Allowed fields to update:
 * - when `fieldOrigin` is `CUSTOM`: `name`, `defaultPrivacy`, `socialType`.
 * - when `fieldOrigin` is `CONTACT` or `SYSTEM`: `defaultPrivacy`.
 * @param _id - Field ID.
 * @public
 * @documentationMaturity preview
 * @requiredField _id
 * @requiredField field
 * @requiredField field.revision
 * @adminMethod
 * @returns Updated custom field.
 */
export function updateCustomField(_id, field) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { field: { '*': '$[1]', id: '$[0]' } };
        const responseTransformation = '$.field';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _updateCustomFieldRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['field']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _updateCustomFieldResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['field']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([_id, field]);
        const reqOpts = ambassadorWixMembersV1CustomField.updateCustomField(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                '_id',
                'field',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Deletes a custom field.
 *
 * After this action, related custom field in Contacts List will also be removed.
 * @param _id - ID of the custom field to delete.
 * @param revision - Revision number.
 * @public
 * @documentationMaturity preview
 * @requiredField _id
 * @requiredField revision
 * @adminMethod
 */
export function deleteCustomField(_id, revision) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { id: '$[0]', revision: '$[1]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _deleteCustomFieldRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _deleteCustomFieldResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([_id, revision]);
        const reqOpts = ambassadorWixMembersV1CustomField.deleteCustomField(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                '_id',
                'revision',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Hides a custom field.
 *
 * Hidden field will be removed from the members custom fields list, yet it will be available as a suggested field to be add later.
 *
 * After this action, related contacts custom field will still be available in the Contacts List.
 * @param _id - ID of the custom field to hide.
 * @param revision - Revision number.
 * @public
 * @documentationMaturity preview
 * @requiredField _id
 * @requiredField revision
 * @adminMethod
 */
export function hideCustomField(_id, revision) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { id: '$[0]', revision: '$[1]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _hideCustomFieldRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _hideCustomFieldResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([_id, revision]);
        const reqOpts = ambassadorWixMembersV1CustomField.hideCustomField(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                '_id',
                'revision',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Updates custom fields order within a section.
 * @param fieldIds - Ordered custom field ids.
 * @public
 * @documentationMaturity preview
 * @requiredField fieldIds
 * @adminMethod
 */
export function updateCustomFieldsOrder(fieldIds, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { fieldIds: '$[0]', section: '$[1].section' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _updateCustomFieldsOrderRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _updateCustomFieldsOrderResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#fields']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([fieldIds, options]);
        const reqOpts = ambassadorWixMembersV1CustomField.updateCustomFieldsOrder(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'fieldIds',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=members-v1-custom-field.universal.js.map